{
  "collectionLabel": "Förslag"
}
